module.exports = __webpack_public_path__ + "img/LADY HAT BW.7bd3d03.svg";